import React from "react";

import { GridItem, GridRow } from "commons/ui/Grid";
import Select from "commons/ui/input/Select";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { MaterialsListHook } from "hooks/list/useMaterialsList";

function MaterialsExtraFilters({ materialsListHook }: { materialsListHook: MaterialsListHook }) {
    const { staticFilterHook, typeOptions, categoryOptions, subcategoryOptions } = materialsListHook;
    const { setValue, form } = staticFilterHook;

    return (
        <GridRow>
            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Tipologia"}
                    options={typeOptions}
                    setValue={setValue}
                    value={form.type}
                    path={"type"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>

            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Categoria"}
                    options={categoryOptions}
                    setValue={setValue}
                    value={form.material_category_id}
                    path={"material_category_id"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>

            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Sottocategoria"}
                    options={subcategoryOptions}
                    setValue={setValue}
                    value={form.material_subcategory_id}
                    path={"material_subcategory_id"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>
        </GridRow>
    );
}

function MaterialsTableFilters({ materialsListHook }: { materialsListHook: MaterialsListHook }) {
    const { onSearchFilterChange, filterSearchHook, staticFilterHook } = materialsListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;
    const { clearStaticFilters } = staticFilterHook;

    const clearAllFilters = React.useCallback(() => {
        clearFilters();
        clearStaticFilters();
    }, [clearFilters, clearStaticFilters]);

    return (
        <FiltersContainer
            applyFilters={applyFilters}
            clearFilters={clearAllFilters}
            extraFilters={<MaterialsExtraFilters materialsListHook={materialsListHook} />}
            openDefault={staticFilterHook.filters.length > 0}
        >
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.art_rr}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default MaterialsTableFilters;
